import { ChangeDetectionStrategy, Component } from "@angular/core";
import { MatDialogRef } from "@angular/material/dialog";

@Component({
  selector: "app-new-version",
  standalone: true,
  imports: [],
  template: `<div class="new-version-container">
    <p>
      ¡Hay una nueva actualización disponible! Actualiza ahora para disfrutar de
      las últimas mejoras.
    </p>
    <button class="btn-update" (click)="onUpdate()">Actualizar</button>
  </div>`,
  styleUrl: "./new-version.component.scss",
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class NewVersionComponent {
  constructor(private dialogRef: MatDialogRef<NewVersionComponent>) {}

  onUpdate() {
    this.dialogRef.close(true);
  }
}
